import { Box, Center } from '@mantine/core';

import { AuthHeader } from '@/components/layout';
import { VerifyEmailCard } from '@/features/auth/components/VerifyEmailCard';

export const VerifyEmailPage = () => {
  return (
    <Box mih="100dvh" style={{ backgroundColor: 'var(--color-bg-canvas)' }}>
      <AuthHeader />
      <Center px={{ base: 16, md: 24 }} py={{ base: 32, md: 80 }}>
        <VerifyEmailCard />
      </Center>
    </Box>
  );
};
